var WamsStrategyService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AflaModuleStrategyService } from "./afla-module-strategy.service";
import { SaShortDatePipe } from "../../pipes/sa-short-date/sa-short-date.pipe";
import { ModuleConfig } from "../../models/module-config.model";
import { SharedConstants } from "../../constants/shared.constants";
import { ApplicationSearchService } from "../../../view-application/shared/application-search.service";
import { map } from "rxjs/operators";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { BehaviorSubject } from "rxjs";
import { AppControllerService } from "../../../app-controller.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { OdataQueryService } from "../odata-query/odata-query.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { ApiWayleaveConstants } from "../../constants/api-constants/api-wayleave.constants";
import { AlertType } from "../../models/alert";
import { WktConverterUtils } from "../../utils/wkt-converter-utils";
import { ApplicationSearchConstants } from "../../../view-application/shared/application-search-constants";
import { ODataAction } from "../odata-query/odata-action.model";
import { RequestStatusService } from "../request-status/request-status.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ViewApplicationRoutingConstants } from "../../../view-application/view-application-routing.constants";
import { ApiApplicationSearchConstants } from "../../constants/api-constants/api-application-search.constants";
import RecipientUtils from "../../../shared/utils/recipient-utils";
import { SelectedApplicationService } from "../selected-application/selected-application.service";
import { ApiLookupConstants } from "../../constants/api-constants/api-lookup.constants";
import { CreateApplicationDetailsWamsComponent } from "../../../create-application/modules/w/create-application-details-wams/create-application-details-wams.component";
import { CreateApplicationLocationWamsComponent } from "../../../create-application/modules/w/create-application-location-wams/create-application-location-wams.component";
import { CreateApplicationProfessionalBodiesWamsComponent } from "../../../create-application/modules/w/create-application-professional-bodies-wams/create-application-professional-bodies-wams.component";
import { ViewApplicationDetailsWamsComponent } from "../../../view-application/modules/w/view-application-details-wams/view-application-details-wams.component";
import { ViewApplicationLocationWamsComponent } from "../../../view-application/modules/w/view-application-location-wams/view-application-location-wams.component";
import { ViewApplicationProfessionalBodiesWamsComponent } from "../../../view-application/modules/w/view-application-professional-bodies-wams/view-application-professional-bodies-wams.component";
import { ApplicationCreateService } from "../../../create-application/shared/application-create.service";
import { CreateApplicationLocationBpamsConstants } from "../../../create-application/modules/bp/create-application-location-bpams/create-application-location-bpams.constants";
import { ApiWorkflowConstants } from "../../constants/api-constants/api-workflow.constants";
import { AutoUnsubPortal } from "../../decorators/autounsub-portal.decorator";
import { CreateApplicationNotesComponent } from "../../../create-application/create-application-notes/create-application-notes.component";
import { ViewApplicationNotesComponent } from "../../../view-application/view-application-notes/view-application-notes.component";
export var ApplicationHeadingEnum;
(function (ApplicationHeadingEnum) {
    ApplicationHeadingEnum["ReferenceNumber"] = "Reference Number";
    ApplicationHeadingEnum["Applicant"] = "Applicant";
    ApplicationHeadingEnum["Agent"] = "Agent";
    ApplicationHeadingEnum["CreatedDate"] = "Start Date";
    ApplicationHeadingEnum["ApplicationStatus"] = "Application Status";
    ApplicationHeadingEnum["DaysLeft"] = "Days left";
    ApplicationHeadingEnum["LastEditedBy"] = "Last Edited By";
    ApplicationHeadingEnum["LastEditedOn"] = "Last Edited On";
    ApplicationHeadingEnum["clientReferenceNumber"] = "Client Reference Number";
    ApplicationHeadingEnum["description"] = "Description";
    ApplicationHeadingEnum["proposedStartDate"] = "Proposed Start Date";
    ApplicationHeadingEnum["proposedEndDate"] = "Proposed End Date";
})(ApplicationHeadingEnum || (ApplicationHeadingEnum = {}));
export const applicationHeadingLookup = new Map([[ApplicationHeadingEnum.ReferenceNumber, "referenceNumber"], [ApplicationHeadingEnum.Applicant, "applicant"], [ApplicationHeadingEnum.Agent, "agent"], [ApplicationHeadingEnum.CreatedDate, "startDate"], [ApplicationHeadingEnum.ApplicationStatus, "phase"], [ApplicationHeadingEnum.DaysLeft, "daysLeft"], [ApplicationHeadingEnum.LastEditedBy, "lastEditedBy"], [ApplicationHeadingEnum.LastEditedOn, "lastEditedOn"], [ApplicationHeadingEnum.clientReferenceNumber, "clientReferenceNumber"], [ApplicationHeadingEnum.description, "description"], [ApplicationHeadingEnum.proposedStartDate, "proposedStartDate"], [ApplicationHeadingEnum.proposedEndDate, "proposedEndDate"],]);
export var ApplicationSummaryColumnsEnum;
(function (ApplicationSummaryColumnsEnum) {
    ApplicationSummaryColumnsEnum["ReferenceNumber"] = "Reference Number";
    ApplicationSummaryColumnsEnum["Applicant"] = "Applicant";
    ApplicationSummaryColumnsEnum["Agent"] = "Agent";
    ApplicationSummaryColumnsEnum["CreatedDate"] = "Start Date";
    ApplicationSummaryColumnsEnum["Phase"] = "Application status";
    ApplicationSummaryColumnsEnum["DaysLeft"] = "Days left";
    ApplicationSummaryColumnsEnum["LastEditedBy"] = "Last Edited By";
    ApplicationSummaryColumnsEnum["LastEditedOn"] = "Last Edited On";
    ApplicationSummaryColumnsEnum["clientReferenceNumber"] = "Client Reference Number";
    ApplicationSummaryColumnsEnum["description"] = "Description";
    ApplicationSummaryColumnsEnum["proposedStartDate"] = "Proposed Start Date";
    ApplicationSummaryColumnsEnum["proposedEndDate"] = "Proposed End Date";
})(ApplicationSummaryColumnsEnum || (ApplicationSummaryColumnsEnum = {}));
export const applicationSummaryColumnsLookup = new Map([[ApplicationSummaryColumnsEnum.ReferenceNumber, "referenceNumber"], [ApplicationSummaryColumnsEnum.Applicant, "applicant"], [ApplicationSummaryColumnsEnum.Agent, "agent"], [ApplicationSummaryColumnsEnum.CreatedDate, "startDate"], [ApplicationSummaryColumnsEnum.Phase, "phase"], [ApplicationSummaryColumnsEnum.DaysLeft, "daysLeft"], [ApplicationSummaryColumnsEnum.LastEditedBy, "lastEditedBy"], [ApplicationSummaryColumnsEnum.LastEditedOn, "lastEditedOn"], [ApplicationSummaryColumnsEnum.clientReferenceNumber, "clientReferenceNumber"], [ApplicationSummaryColumnsEnum.description, "description"], [ApplicationSummaryColumnsEnum.proposedStartDate, "proposedStartDate"], [ApplicationSummaryColumnsEnum.proposedEndDate, "proposedEndDate"],]);
export const WExpandListForApplicationPartial = ApplicationSearchConstants.APP_EXPAND_PORTAL_APP_W;
export var CreateApplicationMenuHeadings;
(function (CreateApplicationMenuHeadings) {
    CreateApplicationMenuHeadings["Welcome"] = "Welcome";
    CreateApplicationMenuHeadings["Location"] = "Location";
    CreateApplicationMenuHeadings["Details"] = "Application";
    CreateApplicationMenuHeadings["Applicant"] = "Applicant";
    CreateApplicationMenuHeadings["Agent"] = "Agent";
    CreateApplicationMenuHeadings["ProfessionalBodies"] = "Professional bodies";
    CreateApplicationMenuHeadings["Notes"] = "Notes";
    CreateApplicationMenuHeadings["Documentation"] = "Required documentation";
})(CreateApplicationMenuHeadings || (CreateApplicationMenuHeadings = {}));
export var HeaderConfigurableTextTypes;
(function (HeaderConfigurableTextTypes) {
    HeaderConfigurableTextTypes["Welcome"] = "Welcome help";
    HeaderConfigurableTextTypes["Location"] = "Property help";
    HeaderConfigurableTextTypes["Details"] = "Application help";
    HeaderConfigurableTextTypes["Applicant"] = "Applicant help";
    HeaderConfigurableTextTypes["Agent"] = "Agent help";
    HeaderConfigurableTextTypes["ProfessionalBodies"] = "Professional bodies help";
    HeaderConfigurableTextTypes["Notes"] = "Notes help";
    HeaderConfigurableTextTypes["Documentation"] = "Required documentation help";
    HeaderConfigurableTextTypes["Communication"] = "Communication help";
    HeaderConfigurableTextTypes["Comments"] = "Comments help";
    HeaderConfigurableTextTypes["Summary"] = "Summary help";
})(HeaderConfigurableTextTypes || (HeaderConfigurableTextTypes = {}));
export var PageConfigurableTextTypes;
(function (PageConfigurableTextTypes) {
    PageConfigurableTextTypes["Welcome"] = "Welcome page";
})(PageConfigurableTextTypes || (PageConfigurableTextTypes = {}));
export const CreateAppHeadingConfigurableTextType = new Map()
    .set(CreateApplicationMenuHeadings.Welcome, HeaderConfigurableTextTypes.Welcome)
    .set(CreateApplicationMenuHeadings.Location, HeaderConfigurableTextTypes.Location)
    .set(CreateApplicationMenuHeadings.Details, HeaderConfigurableTextTypes.Details)
    .set(CreateApplicationMenuHeadings.Applicant, HeaderConfigurableTextTypes.Applicant)
    .set(CreateApplicationMenuHeadings.ProfessionalBodies, HeaderConfigurableTextTypes.ProfessionalBodies)
    .set(CreateApplicationMenuHeadings.Notes, HeaderConfigurableTextTypes.Notes)
    .set(CreateApplicationMenuHeadings.Documentation, HeaderConfigurableTextTypes.Documentation);
export const CreateAppPageConfigurableTextType = new Map()
    .set(CreateApplicationMenuHeadings.Welcome, PageConfigurableTextTypes.Welcome);
export var ViewApplicationMenuHeadings;
(function (ViewApplicationMenuHeadings) {
    ViewApplicationMenuHeadings["Status"] = "Application status";
    ViewApplicationMenuHeadings["Location"] = "Property";
    ViewApplicationMenuHeadings["Details"] = "Application";
    ViewApplicationMenuHeadings["Applicant"] = "Applicant";
    ViewApplicationMenuHeadings["Agent"] = "Agent";
    ViewApplicationMenuHeadings["ProfessionalBodies"] = "Professional bodies";
    ViewApplicationMenuHeadings["Notes"] = "Notes";
    ViewApplicationMenuHeadings["Documentation"] = "Required documentation";
    ViewApplicationMenuHeadings["Communication"] = "Communication";
    ViewApplicationMenuHeadings["Comments"] = "Comments";
})(ViewApplicationMenuHeadings || (ViewApplicationMenuHeadings = {}));
export const ViewAppHeadingConfigurableTextType = new Map()
    .set(ViewApplicationMenuHeadings.Status, HeaderConfigurableTextTypes.Summary)
    .set(ViewApplicationMenuHeadings.Location, HeaderConfigurableTextTypes.Location)
    .set(ViewApplicationMenuHeadings.Details, HeaderConfigurableTextTypes.Details)
    .set(ViewApplicationMenuHeadings.Applicant, HeaderConfigurableTextTypes.Applicant)
    .set(ViewApplicationMenuHeadings.ProfessionalBodies, HeaderConfigurableTextTypes.ProfessionalBodies)
    .set(ViewApplicationMenuHeadings.Notes, HeaderConfigurableTextTypes.Notes)
    .set(ViewApplicationMenuHeadings.Documentation, HeaderConfigurableTextTypes.Documentation)
    .set(ViewApplicationMenuHeadings.Communication, HeaderConfigurableTextTypes.Communication)
    .set(ViewApplicationMenuHeadings.Comments, HeaderConfigurableTextTypes.Comments);
let WamsStrategyService = class WamsStrategyService extends AflaModuleStrategyService {
    static { WamsStrategyService_1 = this; }
    saShortDatePipe;
    applicationSearchService;
    appControllerService;
    oDataQueryService;
    applicationCreateService;
    requestStatusService;
    selectedApplicationService;
    http;
    appController;
    router;
    route;
    viewApplicationSteps = [];
    createApplicationMenuHeadings;
    viewApplicationComponentLookup;
    name = ModuleConfig.Wayleaves;
    defaultSearchColumns;
    applicationEndpoint;
    createApplicationComponentLookup;
    viewApplicationMenuHeadings;
    applicationSummaryColumnsMap;
    applicationServiceUrl = ApiWayleaveConstants.URL;
    form;
    userId;
    moduleUsers;
    expandListForApplicationPartial = WExpandListForApplicationPartial;
    lookups = new Map();
    createApplicationSteps = [];
    isFormValidSubject = new BehaviorSubject(false);
    isFormValidAsObservable = this.isFormValidSubject.asObservable();
    createAppHeadingConfigurableTextType = CreateAppHeadingConfigurableTextType;
    viewAppHeadingConfigurableTextType = ViewAppHeadingConfigurableTextType;
    createAppPageConfigurableTextType = CreateAppPageConfigurableTextType;
    previousApplication = null;
    statusColumn = "status/ workflowSection";
    savedApplication;
    getApplicationsSubscription;
    createApplicationWamsSubscription;
    constructor(saShortDatePipe, applicationSearchService, appControllerService, oDataQueryService, applicationCreateService, requestStatusService, selectedApplicationService, http, appController, router, route) {
        super();
        this.saShortDatePipe = saShortDatePipe;
        this.applicationSearchService = applicationSearchService;
        this.appControllerService = appControllerService;
        this.oDataQueryService = oDataQueryService;
        this.applicationCreateService = applicationCreateService;
        this.requestStatusService = requestStatusService;
        this.selectedApplicationService = selectedApplicationService;
        this.http = http;
        this.appController = appController;
        this.router = router;
        this.route = route;
        this.initForm();
        this.applicationEndpoint = `${ApiWayleaveConstants.URL}/${ApiWayleaveConstants.FUNCTION_GET_MY_AFLA_PORTAL_WAYLEAVE_APPLICATIONS}`;
        this.createApplicationMenuHeadings = CreateApplicationMenuHeadings;
        this.viewApplicationMenuHeadings = ViewApplicationMenuHeadings;
        super.init();
    }
    static getRecipientFullName(firstName, surname) {
        if (!firstName && !surname) {
            return "";
        }
        if (!firstName) {
            return surname;
        }
        return `${firstName} ${surname}`;
    }
    static getRecipientName(recipient) {
        if (!recipient) {
            return "";
        }
        return this.getRecipientFullName(recipient.name, recipient.surname);
    }
    static getFirstRecipient(recipients) {
        if (recipients && recipients.length > 0) {
            return recipients[0];
        }
    }
    static buildExpand(params) {
        return params.set(ODataAction.Expand, WExpandListForApplicationPartial);
    }
    buildListFilter(list, column) {
        const params = WamsStrategyService_1.buildExpand(new HttpParams());
        return this.oDataQueryService.buildFilterFromArray(params, column, list);
    }
    initializeApplicationSummaryColumnsMap() {
        this.applicationSummaryColumnsMap = applicationSummaryColumnsLookup;
    }
    // TODO: FIX THIS -> WAMS fields
    defaultSearchModel(application) {
        return {
            id: application.id,
            appId: application.appId,
            jobId: application.jobId,
            referenceNumber: application.referenceNumber,
            applicant: WamsStrategyService_1.getRecipientName(WamsStrategyService_1.getFirstRecipient(application.applicant)),
            agent: WamsStrategyService_1.getRecipientName(WamsStrategyService_1.getFirstRecipient(application.applicantAgent)),
            startDate: this.saShortDatePipe.transform(application.createdDate), // TODO: we have relabelled all instances of "Phase" to "Application status"
            //  - do we need to do the same for the property name "phase" => "applicationStatus" for consistency?
            //  - don't forget to apply to all module services!!
            phase: application.status?.workflowSection,
            daysLeft: application.status?.daysUntilExpired,
            lastEditedBy: this.getLastEditedByUser(application.lastEditedUser),
            lastEditedOn: application.lastEditedDate !== null ? this.saShortDatePipe.transform(application.lastEditedDate) : "",
            moduleId: application.moduleId,
            clientReferenceNumber: "",
            description: "Description",
            proposedStartDate: "Proposed Start Date",
            proposedEndDate: "Proposed End Date"
        };
    }
    getLastEditedByUser(lastEditedUser) {
        return lastEditedUser ? `${lastEditedUser.lastName}, ${lastEditedUser.firstName}` : "";
    }
    getUserName(user) {
        return user ? `${user.lastName}, ${user.firstName}` : "";
    }
    getUserNameFromId(userId) {
        let userName = "";
        if (userId) {
            this.applicationSearchService.moduleUsers.forEach((user) => {
                if (Number(user.id) === userId)
                    userName = `${user.lastName}, ${user.firstName}`;
            });
        }
        return userName;
    }
    mapFromApplicationEntityToApplicationSearchModel(application) {
        return this.defaultSearchModel(application);
    }
    initializeCreateApplicationComponents() {
        this.createApplicationComponentLookup = new Map([
            [CreateApplicationMenuHeadings.Details, CreateApplicationDetailsWamsComponent],
            [CreateApplicationMenuHeadings.Location, CreateApplicationLocationWamsComponent],
            [CreateApplicationMenuHeadings.ProfessionalBodies, CreateApplicationProfessionalBodiesWamsComponent],
            [CreateApplicationMenuHeadings.Notes, CreateApplicationNotesComponent],
        ]);
    }
    initializeViewApplicationComponents() {
        this.viewApplicationComponentLookup = new Map([
            [ViewApplicationMenuHeadings.Details, ViewApplicationDetailsWamsComponent],
            [ViewApplicationMenuHeadings.Location, ViewApplicationLocationWamsComponent],
            [ViewApplicationMenuHeadings.ProfessionalBodies, ViewApplicationProfessionalBodiesWamsComponent],
            [ViewApplicationMenuHeadings.Notes, ViewApplicationNotesComponent]
        ]);
    }
    getApplicationsQuery(params) {
        return this.http.get(this.applicationEndpoint, { params });
    }
    getAllApplicationsQuery(params) {
        return this.http.get(`${ApiWayleaveConstants.URL}/${ApiWayleaveConstants.FUNCTION_GET_MY_AFLA_PORTAL_WAYLEAVE_APPLICATIONS}`, { params });
    }
    buildApplicationSearchBaseRequest(moduleID) {
        let params = WamsStrategyService_1.buildExpand(new HttpParams());
        params = this.oDataQueryService.filter(params, WamsStrategyService_1.buildModuleIDFilter(moduleID));
        return this.getApplicationsQuery(params);
    }
    createApplication(existingApplication) {
        const application = this.buildApplication(existingApplication);
        this.createApplicationWamsSubscription = this.postApplicationService(application).subscribe((savedApplication) => {
            this.appController.showMessage(WamsStrategyService_1.successMessage(savedApplication.referenceNumber, ""), AlertType.Success);
            this.resetForm();
            this.router.navigate([AppRoutingConstants.createRouteToView(this.appController.selectedModuleID + "", ViewApplicationRoutingConstants.VIEW_APPLICATION_ROUTE, savedApplication.jobId + "")]);
        }, (error) => {
            this.appController.handleServerErrorMessage("application", error, CRUDOperation.Add);
        });
    }
    setApplicationNotes(stepIndex, existingApplication) {
        const noteId = this.form.get("notesForm").get("id").value ? this.form.get("notesForm").get("id").value : 0;
        const noteValue = this.form.get("notesForm").get("note").value;
        let note;
        if (noteValue !== null && noteValue !== "") {
            note = [{ id: noteId, note: noteValue }];
        }
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.notes = note;
            application.eLodgementStep = stepIndex;
        }
        else {
            application = {
                id: 0,
                deleted: false,
                moduleId: Number(this.appController.selectedModuleID),
                notes: note,
                eLodgementComplete: false,
                eLodgementStep: stepIndex
            };
        }
        return application;
    }
    saveApplicationStep(step, existingApplication, missingLookupsForZones, continueAfterSave = true) {
        let application;
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationMenuHeadings.Location.toLocaleLowerCase():
                application = this.buildLocationStep(step.stepIndex, existingApplication, missingLookupsForZones);
                break;
            case CreateApplicationMenuHeadings.Details.toLocaleLowerCase():
                application = this.buildDetailsStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationMenuHeadings.Applicant.toLocaleLowerCase():
                application = this.buildApplicantStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationMenuHeadings.Agent.toLocaleLowerCase():
                application = this.buildApplicantAgentStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationMenuHeadings.ProfessionalBodies.toLocaleLowerCase():
                application = this.buildProfessionalBodiesStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationMenuHeadings.Notes.toLocaleLowerCase():
                application = this.setApplicationNotes(step.stepIndex, existingApplication);
                break;
            case CreateApplicationMenuHeadings.Documentation.toLocaleLowerCase():
                application = this.buildDocumentationStep(step.stepIndex, existingApplication);
                break;
            default:
                break;
        }
        if (application) {
            const applicationId = application.id > 0 ? application.id : 0;
            this.savedApplication = undefined;
            const applicationRequestDto = {
                wApplication: application,
                moveApplicationToNextStepAfterSave: continueAfterSave
            };
            this.createPartialApplicationObservable(applicationId, applicationRequestDto).subscribe({
                next: (savedApplication) => {
                    // had to do this because the saved application object does not return with the latest property owners
                    const params = {
                        $expand: "applicationLines,applicationPolygons,notes,attachments",
                        $filter: `jobId eq ${savedApplication.jobId} and moduleId eq ${+this.appControllerService.selectedModuleID}`
                    };
                    this.getApplicationsSubscription = this.getApplicationsQuery(params).subscribe({
                        next: (response) => {
                            const applicationLines = response.value[0]?.applicationLines;
                            const applicationPolygons = response.value[0]?.applicationPolygons;
                            savedApplication.applicationLines = applicationLines;
                            savedApplication.applicationPolygons = applicationPolygons;
                            if (continueAfterSave && !savedApplication.eLodgementComplete) {
                                --savedApplication.eLodgementStep;
                            }
                            this.savedApplication = savedApplication;
                        }, error: (error) => {
                            this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                            this.requestStatusService.removeBusySpinner("continueToNextStep");
                        }, complete: () => {
                            if (this.savedApplication && continueAfterSave) {
                                this.selectedApplicationService.setIncompleteJobId(this.savedApplication.jobId);
                                this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                                this.appController.showMessage(WamsStrategyService_1.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success, true);
                            }
                            else {
                                // NB: THIS WILL FIX ISSU WITH THE SAVE BUTTON JUMPING TO THE NEXT STEP, NOT SO ELEGANT I KNOW... FILL FREE TO REMOVE IT IT YOU HAVE BETTER IDEA.
                                this.savedApplication.eLodgementStep = applicationRequestDto.wApplication.eLodgementStep;
                                this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                                this.appController.showMessage(WamsStrategyService_1.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success, true);
                            }
                            this.requestStatusService.removeBusySpinner("continueToNextStep");
                            this.requestStatusService.removeBusySpinner("TrueCentroid");
                        }
                    });
                }, error: (error) => {
                    this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                    this.requestStatusService.removeBusySpinner("continueToNextStep");
                }
            });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Error);
            if (continueAfterSave && continueAfterSave) {
                this.setIsFormValidSubject(false);
            }
            this.requestStatusService.removeBusySpinner("continueToNextStep");
        }
    }
    saveResubmittedApplication(step, continueAfterSave, application) {
        application.elodgementStep = step.stepIndex;
        this.creatResubmittedApplicationObservable(0, application, continueAfterSave).subscribe({
            next: (savedApplication) => {
                this.previousApplication = null;
                const params = {
                    $expand: this.expandListForApplicationPartial,
                    $filter: `jobId eq ${savedApplication.jobId} and moduleId eq ${+savedApplication.moduleId}`
                };
                this.getApplicationsSubscription = this.getApplicationsQuery(params).subscribe({
                    next: (response) => {
                        if (continueAfterSave && !savedApplication.eLodgementComplete) {
                            --savedApplication.eLodgementStep;
                        }
                        this.savedApplication = savedApplication;
                    },
                    error: (error) => {
                        this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                        this.requestStatusService.removeBusySpinner("continueToNextStep");
                    },
                    complete: () => {
                        if (this.savedApplication && continueAfterSave) {
                            this.selectedApplicationService.setIncompleteJobId(this.savedApplication.jobId);
                            this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                            this.appController.showMessage(AflaModuleStrategyService.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success, true);
                        }
                        else {
                            // NB: THIS WILL FIX ISSUE WITH THE SAVE BUTTON JUMPING TO THE NEXT STEP, NOT SO ELEGANT I KNOW... FILL FREE TO REMOVE IT IF YOU HAVE BETTER IDEA.
                            // this.savedApplication.eLodgementStep = applicationRequestDto.bpApplication.eLodgementStep;
                            this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                            this.appController.showMessage(AflaModuleStrategyService.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success, true);
                        }
                        this.requestStatusService.removeBusySpinner("continueToNextStep");
                        this.requestStatusService.removeBusySpinner("TrueCentroid");
                    }
                });
            }, error: (error) => {
                this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                this.requestStatusService.removeBusySpinner("continueToNextStep");
            }
        });
    }
    createPartialApplicationObservable(applicationId, params) {
        return this.http.post(`${ApiWayleaveConstants.URL}/${applicationId}/${ApiWayleaveConstants.FUNCTION_CREATE_PARTIAL_APPLICATION}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    creatResubmittedApplicationObservable(applicationId, applicationRequestDto, continueAfterSave) {
        const requestObject = {
            moveApplicationToNextStepAfterSave: true,
            wApplication: applicationRequestDto
        };
        return this.http.post(`${ApiWayleaveConstants.URL}/${applicationId}/${ApiWayleaveConstants.FUNCTION_CREATE_RESUBMITTED_APPLICATION}`, requestObject)
            .pipe(map((response) => {
            return response;
        }));
    }
    getCurrentFormName(step) {
        if (step === null)
            return "";
        let formName = "";
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationMenuHeadings.Location.toLocaleLowerCase():
                formName = "locationForm";
                break;
            case CreateApplicationMenuHeadings.Details.toLocaleLowerCase():
                formName = "detailsForm";
                break;
            case CreateApplicationMenuHeadings.Applicant.toLocaleLowerCase():
                formName = "applicantForm";
                break;
            case CreateApplicationMenuHeadings.Agent.toLocaleLowerCase():
                formName = "applicantAgentForm";
                break;
            case CreateApplicationMenuHeadings.ProfessionalBodies.toLocaleLowerCase():
                formName = "professionalBodiesForm";
                break;
            case CreateApplicationMenuHeadings.Notes.toLocaleLowerCase():
                formName = "notesForm";
                break;
            case CreateApplicationMenuHeadings.Documentation.toLocaleLowerCase():
                formName = "documentForm";
                break;
            default:
                break;
        }
        return formName;
    }
    resetFormForStep(step) {
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationMenuHeadings.Applicant.toLocaleLowerCase():
                this.form.get("applicantForm").get("applicantRecipient").reset();
                break;
            case CreateApplicationMenuHeadings.Agent:
                this.form.get("applicantAgentForm").get("applicantAgentRecipient").reset();
                break;
            case CreateApplicationMenuHeadings.Details.toLocaleLowerCase():
                this.form.get("detailsForm").get("description").reset();
                this.form.get("detailsForm").get("applicationType").reset();
                this.form.get("detailsForm").get("services").reset();
                this.form.get("detailsForm").get("clientReferenceNumber").reset();
                this.form.get("detailsForm").get("applicantTelecommunicationLicenseNumber").reset();
                this.form.get("detailsForm").get("scopeOfWork").reset();
                this.form.get("detailsForm").get("estimatedConstructionCost").reset();
                this.form.get("detailsForm").get("applicationFee").reset();
                this.form.get("detailsForm").get("constructionPeriod").reset();
                this.form.get("detailsForm").get("constructionPeriodUnits").reset();
                this.form.get("detailsForm").get("proposedStartDate").reset();
                this.form.get("detailsForm").get("proposedEndDate").reset();
                this.form.get("detailsForm").get("laneClosureIsRequired").reset();
                this.form.get("detailsForm").get("laneClosureExtent").reset();
                this.form.get("detailsForm").get("electricalServices").reset();
                this.form.get("detailsForm").get("actualStartDate").reset();
                this.form.get("detailsForm").get("actualEndDate").reset();
                break;
            case CreateApplicationMenuHeadings.Location.toLocaleLowerCase():
                this.applicationCreateService.$clearLayerGraphicsSubject.next(true);
                this.form.get("locationForm").get("selectedGraphic").reset();
                this.form.get("locationForm").get("centroid").reset();
                this.form.get("locationForm").get("polyline").reset();
                this.form.get("locationForm").get("polygon").reset();
                this.form.get("locationForm").get("polylineDto").reset();
                this.form.get("locationForm").get("polygonDto").reset();
                this.form.get("locationForm").get("referenceNumber").reset();
                this.form.get("locationForm").get("isResubmission").reset();
                this.form.get("locationForm").get("previousReferenceNumber").reset();
                break;
            case CreateApplicationMenuHeadings.ProfessionalBodies.toLocaleLowerCase():
                this.form.get("professionalBodiesForm").get("markImplementingAgentAsRequired").reset();
                this.form.get("professionalBodiesForm").get("implementingAgentRecipient").reset();
                this.form.get("professionalBodiesForm").get("markEngineerAsRequired").reset();
                this.form.get("professionalBodiesForm").get("engineerRecipients").reset();
                this.form.get("professionalBodiesForm").get("markElectricalContractorAsRequired").reset();
                this.form.get("professionalBodiesForm").get("responsibleContractorRecipient").reset();
                this.form.get("professionalBodiesForm").get("copyApplicantToImplementingAgent").reset();
                this.form.get("professionalBodiesForm").get("copyApplicantToEngineer").reset();
                this.form.get("professionalBodiesForm").get("copyApplicantToContractor").reset();
                break;
            case CreateApplicationMenuHeadings.Documentation.toLocaleLowerCase():
                break;
            case CreateApplicationMenuHeadings.Notes.toLocaleLowerCase():
                break;
            default:
                break;
        }
    }
    resetForm() {
        this.form.reset();
    }
    postApplicationService(params) {
        return this.http.post(ApiWayleaveConstants.URL, params);
    }
    withdrawApplication(params) {
        return this.http.post(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_WITHDRAW_APPLICATION, params);
    }
    getWorkflowClosedStates() {
        return this.http.get(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_GET_WORKFLOW_CLOSED_STATES);
    }
    // TODO: Correct these return values
    getSelectedApplicationSummaryExpand() {
        return "status, applicant, applicant($expand=groups), applicantAgent, lastEditedUser";
    }
    getSearchUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_W_APPLICATIONS_BY_USER;
        }
    }
    initialiseCreateApplicationSteps() {
        this.createApplicationSteps = [];
        for (const [key, value] of Object.entries(CreateApplicationMenuHeadings)) {
            const step = {
                // this will be fixed - the others will be configurable
                stepId: `step_${key}`, // TODO: Can use something like this if required `${stepName} Sub-title`
                stepSubtitle: "",
                stepTitle: `${value}`,
                stepType: key === CreateApplicationMenuHeadings.Welcome ? "active" /* CalciteStepperItemType.active */ : "disabled" /* CalciteStepperItemType.disabled */, // TODO: Can use something like this if required `content`
                stepContent: ``,
            };
            this.createApplicationSteps.push(step);
        }
    }
    initialiseViewApplicationSteps() {
        this.viewApplicationSteps = [];
        for (const [key, value] of Object.entries(ViewApplicationMenuHeadings)) {
            const step = {
                // this will be fixed - the others will be configurable
                stepId: `step_${key}`, // TODO: Can use something like this if required `${stepName} Sub-title`
                stepSubtitle: "",
                stepTitle: `${value}`,
                stepType: key === ViewApplicationMenuHeadings.Status ? "active" /* CalciteStepperItemType.active */ : "disabled" /* CalciteStepperItemType.disabled */, // TODO: Can use something like this if required `content`
                stepContent: ``,
            };
            this.viewApplicationSteps.push(step);
        }
    }
    getCreateApplicationStepsLookup(stepId) {
        const keys = [...this.createApplicationSteps.entries()]
            .filter(({ 1: v }) => v.stepId === stepId);
        if (keys.length > 0)
            return keys[0][1];
    }
    getApplicationTypes(jobId, moduleId) {
        const params = {
            moduleId
        };
        const url = `${ApiWayleaveConstants.URL}/${jobId}/GetWApplicationTypes`;
        return this.http.get(url, { params });
    }
    applicationHasGeometry() {
        if (this.form.get("locationForm") && this.form.get("locationForm").get("centroid").value !== null) {
            return true;
        }
        else {
            this.appController.showMessage(CreateApplicationLocationBpamsConstants.PROPERTY_REQUIRED, AlertType.Warning);
            return false;
        }
    }
    queryConfigurableTextLookup(filter) {
        const params = {
            $filter: filter
        };
        return this.http.get(`${ApiLookupConstants.URL}/${ApiLookupConstants.FUNCTION_GET_LOOKUPS_FOR_AFLA_PORTAL}`, { params });
    }
    initForm() {
        this.form = new FormGroup({
            locationForm: new FormGroup({
                selectedGraphic: new FormControl(null),
                centroid: new FormControl(null, [Validators.required]),
                polyline: new FormControl(null),
                polygon: new FormControl(null),
                polylineDto: new FormControl(null),
                polygonDto: new FormControl(null),
                referenceNumber: new FormControl(null),
                isResubmission: new FormControl(null, [Validators.required]),
                previousReferenceNumber: new FormControl(null),
                acceptControl: new FormControl(null)
            }),
            detailsForm: new FormGroup({
                description: new FormControl(null, [Validators.required]),
                applicationType: new FormControl(null, [Validators.required]),
                services: new FormControl(null),
                clientReferenceNumber: new FormControl(null, [Validators.required]),
                applicantTelecommunicationLicenseNumber: new FormControl(null),
                scopeOfWork: new FormControl(null, [Validators.required]),
                estimatedConstructionCost: new FormControl(null, [Validators.required]),
                applicationFee: new FormControl(null, [Validators.required]),
                constructionPeriod: new FormControl(null),
                constructionPeriodUnits: new FormControl(null),
                proposedStartDate: new FormControl(null, [Validators.required]),
                proposedEndDate: new FormControl(null, [Validators.required]),
                laneClosureIsRequired: new FormControl(null, [Validators.required]),
                laneClosureExtent: new FormControl(null, [Validators.required]),
                electricalServices: new FormControl(null, [Validators.required]),
                actualStartDate: new FormControl(null),
                actualEndDate: new FormControl(null)
            }),
            applicantForm: new FormGroup({
                applicantRecipient: new FormControl(null, [Validators.required]),
            }),
            applicantAgentForm: new FormGroup({
                applicantAgentRecipient: new FormControl(null, [Validators.required]),
                applicantAgentIsNull: new FormControl(null)
            }),
            professionalBodiesForm: new FormGroup({
                markImplementingAgentAsRequired: new FormControl(null),
                implementingAgentRecipient: new FormControl(null),
                markEngineerAsRequired: new FormControl(null),
                engineerRecipients: new FormControl(null),
                markElectricalContractorAsRequired: new FormControl(null),
                responsibleContractorRecipient: new FormControl(null),
                copyApplicantToImplementingAgent: new FormControl(null),
                copyApplicantToEngineer: new FormControl(null),
                copyApplicantToContractor: new FormControl(null),
            }),
            notesForm: new FormGroup({
                id: new FormControl(0),
                note: new FormControl(null)
            }),
            documentForm: new FormGroup({
                documents: new FormArray([]),
            })
        });
    }
    getEntityColumn(searchColumn) {
        return SharedConstants.SEARCH_BY_DEFAULT;
    }
    buildApplication(existingApplication) {
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
        const application = {
            id: existingApplication ? existingApplication.id : 0,
            referenceNumber: "",
            deleted: false,
            moduleId: Number(this.appController.selectedModuleID),
            clientReferenceNumber: this.form.get("detailsForm").get("clientReferenceNumber").value,
            licenceNumber: this.form.get("detailsForm").get("applicantTelecommunicationLicenseNumber").value,
            scopeOfWork: this.form.get("detailsForm").get("scopeOfWork").value,
            estimatedCost: this.form.get("detailsForm").get("estimatedConstructionCost").value,
            applicationFee: this.form.get("detailsForm").get("applicationFee").value,
            constructionPeriod: this.form.get("detailsForm").get("constructionPeriod").value,
            constructionPeriodUnits: this.form.get("detailsForm").get("constructionPeriodUnits").value,
            proposedStartDate: this.form.get("detailsForm").get("proposedStartDate").value,
            proposedEndDate: this.form.get("detailsForm").get("proposedEndDate").value,
            laneClosureRequired: this.form.get("detailsForm").get("laneClosureIsRequired").value,
            laneClosureExtent: this.form.get("detailsForm").get("laneClosureExtent").value,
            electricalServices: this.form.get("detailsForm").get("electricalServices").value,
            description: this.form.get("detailsForm").get("description").value,
            applicationType: this.form.get("detailsForm").get("applicationType").value,
            services: this.form.get("detailsForm").get("services").value,
            shape: "",
            wkid: 102100,
            applicant: [],
            applicantAgent: [],
            implementingAgent: [],
            engineer: [],
            contractor: [],
            eLodgementComplete: false,
            eLodgementStep: 0
        };
        return application;
    }
    buildLocationStep(stepIndex, existingApplication, missingLookupsForZones) {
        let application;
        const centroid = this.form.get("locationForm").get("centroid").value;
        if (existingApplication) {
            application = existingApplication;
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = false;
            application.shape = WktConverterUtils.ConvertArcGISJsonToWkt(centroid);
        }
        else
            application = {
                id: 0,
                moduleId: Number(this.appController.selectedModuleID),
                deleted: false,
                eLodgementStep: stepIndex,
                eLodgementComplete: false,
                shape: WktConverterUtils.ConvertArcGISJsonToWkt(centroid),
                wkid: 102100
            };
        const polyline = this.form.get("locationForm").get("polyline").value;
        const polygon = this.form.get("locationForm").get("polygon").value;
        if (application.applicationPolygons === undefined || application.applicationPolygons === null) {
            application.applicationPolygons = [];
        }
        if (application.applicationLines === undefined || application.applicationLines === null) {
            application.applicationLines = [];
        }
        if (polygon !== null) {
            const applicationPolygon = {
                wkid: 102100, shape: WktConverterUtils.ConvertArcGISJsonToWkt(polygon)
            };
            application.applicationPolygons.push(applicationPolygon);
        }
        if (polyline !== null) {
            const applicationLine = {
                wkid: 102100, shape: WktConverterUtils.ConvertArcGISJsonToWkt(polyline)
            };
            application.applicationLines.push(applicationLine);
        }
        return application;
    }
    buildDetailsStep(stepIndex, existingApplication) {
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = false;
            application.description = this.form.get("detailsForm").get("description").value;
            application.applicationType = this.form.get("detailsForm").get("applicationType").value;
            application.services = this.form.get("detailsForm").get("services").value;
            application.clientReferenceNumber = this.form.get("detailsForm").get("clientReferenceNumber").value;
            application.licenceNumber = this.form.get("detailsForm").get("applicantTelecommunicationLicenseNumber").value;
            application.scopeOfWork = this.form.get("detailsForm").get("scopeOfWork").value;
            application.estimatedCost = this.form.get("detailsForm").get("estimatedConstructionCost").value;
            application.applicationFee = this.form.get("detailsForm").get("applicationFee").value;
            application.constructionPeriod = this.form.get("detailsForm").get("constructionPeriod").value;
            application.constructionPeriodUnits = this.form.get("detailsForm").get("constructionPeriodUnits").value;
            application.proposedStartDate = this.form.get("detailsForm").get("proposedStartDate").value;
            application.proposedEndDate = this.form.get("detailsForm").get("proposedEndDate").value;
            application.laneClosureRequired = this.form.get("detailsForm").get("laneClosureIsRequired").value;
            application.laneClosureExtent = this.form.get("detailsForm").get("laneClosureExtent").value;
            application.electricalServices = this.form.get("detailsForm").get("electricalServices").value;
            application.actualStartDate = this.form.get("detailsForm").get("actualStartDate").value;
            application.actualEndDate = this.form.get("detailsForm").get("actualEndDate").value;
        }
        else
            application = {
                id: 0,
                referenceNumber: "",
                moduleId: Number(this.appController.selectedModuleID),
                eLodgementStep: stepIndex,
                deleted: false,
                eLodgementComplete: false,
                description: this.form.get("detailsForm").get("description").value,
                clientReferenceNumber: this.form.get("detailsForm").get("clientReferenceNumber").value,
                licenceNumber: this.form.get("detailsForm").get("applicantTelecommunicationLicenseNumber").value,
                scopeOfWork: this.form.get("detailsForm").get("scopeOfWork").value,
                estimatedCost: this.form.get("detailsForm").get("estimatedConstructionCost").value,
                applicationFee: this.form.get("detailsForm").get("applicationFee").value,
                constructionPeriod: this.form.get("detailsForm").get("constructionPeriod").value,
                constructionPeriodUnits: this.form.get("detailsForm").get("constructionPeriodUnits").value,
                proposedStartDate: this.form.get("detailsForm").get("proposedStartDate").value,
                proposedEndDate: this.form.get("detailsForm").get("proposedEndDate").value,
                laneClosureRequired: this.form.get("detailsForm").get("laneClosureIsRequired").value,
                laneClosureExtent: this.form.get("detailsForm").get("laneClosureExtent").value,
                electricalServices: this.form.get("detailsForm").get("electricalServices").value,
                actualStartDate: this.form.get("detailsForm").get("actualStartDate").value,
                actualEndDate: this.form.get("detailsForm").get("actualEndDate").value
            };
        return application;
    }
    buildApplicantStep(stepIndex, existingApplication) {
        this.form.get("applicantForm").get("applicantRecipient").enable();
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.applicant = [applicant];
            application.eLodgementStep = stepIndex;
        }
        else
            application = {
                id: 0,
                deleted: false,
                moduleId: Number(this.appController.selectedModuleID),
                applicant: [applicant],
                eLodgementComplete: false,
                eLodgementStep: stepIndex
            };
        return application;
    }
    // TODO: Check if Applicable on WAMS
    buildApplicantAgentStep(stepIndex, existingApplication) {
        this.form.get("applicantAgentForm").get("applicantAgentRecipient").enable();
        const applicantAgentIsNullValue = this.form.get("applicantAgentForm").get("applicantAgentIsNull").value;
        const applicantAgentFormValue = this.form.get("applicantAgentForm").get("applicantAgentRecipient").value;
        const applicantAgent = RecipientUtils.removeInvalidRecipientProperties(applicantAgentFormValue);
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.applicantAgent = applicantAgentIsNullValue ? [] : [applicantAgent];
            application.applicantAgentNa = applicantAgentIsNullValue;
            application.eLodgementStep = stepIndex;
        }
        else
            application = {
                id: 0,
                deleted: false,
                moduleId: Number(this.appController.selectedModuleID),
                applicantAgent: [applicantAgent],
                eLodgementComplete: false,
                eLodgementStep: stepIndex
            };
        if (applicantAgentIsNullValue) {
            this.form.get("applicantAgentForm").get("applicantAgentRecipient").disable();
        }
        return application;
    }
    buildProfessionalBodiesStep(stepIndex, existingApplication) {
        const engineerIsRequired = this.form.get("professionalBodiesForm").get("markEngineerAsRequired").value;
        const contractorIsRequired = this.form.get("professionalBodiesForm").get("markElectricalContractorAsRequired").value;
        const implementingAgentIsRequired = this.form.get("professionalBodiesForm").get("markImplementingAgentAsRequired").value;
        if (contractorIsRequired)
            this.form.get("professionalBodiesForm").get("responsibleContractorRecipient").enable();
        if (engineerIsRequired)
            this.form.get("professionalBodiesForm").get("engineerRecipients").enable();
        if (implementingAgentIsRequired)
            this.form.get("professionalBodiesForm").get("implementingAgentRecipient").enable();
        const implementingAgentFormValue = this.form.get("professionalBodiesForm").get("implementingAgentRecipient").value;
        const implementingAgent = RecipientUtils.removeInvalidRecipientProperties(implementingAgentFormValue);
        const engineerFormValue = this.form.get("professionalBodiesForm").get("engineerRecipients").value;
        const engineer = RecipientUtils.removeInvalidRecipientProperties(engineerFormValue);
        const contractorFormValue = this.form.get("professionalBodiesForm").get("responsibleContractorRecipient").value;
        const contractor = RecipientUtils.removeInvalidRecipientProperties(contractorFormValue);
        let application;
        application = existingApplication;
        application.implementingAgent = implementingAgentIsRequired ? [implementingAgent] : [];
        application.engineer = engineerIsRequired ? [engineer] : [];
        application.contractor = contractorIsRequired ? [contractor] : [];
        application.implementingAgentNa = !implementingAgentIsRequired;
        application.engineerNa = !engineerIsRequired;
        application.contractorNa = !contractorIsRequired;
        application.eLodgementStep = stepIndex;
        return application;
    }
    buildDocumentationStep(stepIndex, existingApplication) {
        let application;
        const attachments = this.form.get("documentForm").get("documents").value;
        if (existingApplication) {
            application = existingApplication;
            application.attachments = attachments;
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = true;
        }
        else
            application = {
                id: 0,
                attachments,
                moduleId: Number(this.appController.selectedModuleID),
                eLodgementStep: stepIndex,
                deleted: false,
                eLodgementComplete: true
            };
        return application;
    }
    verifyResubmissionReferenceNumberObservable(params) {
        return this.http.post(`${ApiWayleaveConstants.URL}/${ApiWayleaveConstants.FUNCTION_VERIFY_RESUBMISSION_REFERENCE_NUMBER}`, params);
    }
    verifyExtensionReferenceNumberObservable(params) {
        return;
    }
    static ctorParameters = () => [
        { type: SaShortDatePipe },
        { type: ApplicationSearchService },
        { type: AppControllerService },
        { type: OdataQueryService },
        { type: ApplicationCreateService },
        { type: RequestStatusService },
        { type: SelectedApplicationService },
        { type: HttpClient },
        { type: AppControllerService },
        { type: Router },
        { type: ActivatedRoute }
    ];
};
WamsStrategyService = WamsStrategyService_1 = __decorate([
    Injectable({
        providedIn: "root",
    }),
    AutoUnsubPortal()
], WamsStrategyService);
export { WamsStrategyService };
